module.exports = __webpack_public_path__ + "img/dialog_image_S101P.91405be6.png";